
import debounce from 'lodash/debounce';
import { defineComponent, PropType, ref } from 'vue';
import { IVatTuResponseBase } from '@/core/interfaces/ApiResponses';
import { swalNotification } from '@/core/helpers/utils';
import { VatTuService } from '@/core/services/VatTu.service';
import { formatUnitPrice } from '@/core/helpers/number-format';
import { ButtonsType, ButtonTypeColors } from '@/core/enums/buttons.enums';
import Pagination from '@/components/shared/pagination/Pagination.vue';
import DanhMucVatTuService from '@/core/services/DanhMucVatTu.service';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import useVatTu from '@/core/hooks/use-vat-tu';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import { FormModalShell } from '@/components/shared/modal';

export default defineComponent({
  components: {
    ButtonCustom,
    FormModalShell,
    LabelCustom,
    Pagination,
  },

  emits: ['close', 'added'],

  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    selectedVatTuItems: {
      type: Array as PropType<Array<IVatTuResponseBase>>,
    },
    danhMucVatTuId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      ButtonsType,
      ButtonTypeColors,
      currentPage: 1,
      isTableLoading: false,
      isOpen: false,
      searchTerm: '',
      selectedVatTuIds: [] as number[],
      selectedVatTuIdArr: [] as boolean[],
      totalItems: 0,
    };
  },

  setup() {
    const vatTuItems = ref<IVatTuResponseBase[]>([]);

    const { isTextDangerColumn, isValidLabel } = useVatTu();

    return {
      vatTuItems,
      isTextDangerColumn,
      isValidLabel,
    };
  },

  watch: {
    isModalOpen: {
      async handler(newValue) {
        if (newValue) {
          this.isOpen = newValue;
          this.currentPage = 1;

          await this.fetchVatTuItems(this.currentPage);

          if (this.selectedVatTuItems) {
            this.selectedVatTuIds = this.selectedVatTuItems.map(
              (item) => item.id
            );

            this.selectedVatTuIdArr = this.vatTuItems.map((item) => {
              return this.selectedVatTuIds.includes(item.id);
            });
          }
        }
      },
      deep: true,
    },

    async currentPage(page) {
      await this.fetchVatTuItems(page);
      if (this.selectedVatTuItems) {
        this.selectedVatTuIdArr = this.vatTuItems.map((item) => {
          return this.selectedVatTuIds.includes(item.id);
        });
      }
    },
  },

  computed: {
    totalVatTuDaChon() {
      return this.selectedVatTuIds.length;
    },

    totalVatTuDangChonTrongPage() {
      let count = 0;
      this.selectedVatTuIdArr.forEach((item) => {
        if (item) count += 1;
      });
      return count;
    },

    labelDisplay() {
      return `Danh sách vật tư (đã chọn ${this.totalVatTuDaChon}, trong trang này ${this.totalVatTuDangChonTrongPage})`;
    },
  },

  methods: {
    formatUnitPrice,

    onChangeVatTuCheckbox({
      row,
      value,
    }: {
      row: IVatTuResponseBase;
      value: boolean;
    }) {
      this.onRowClick(row, value);
    },

    searchForVatTu: debounce(async function () {
      if (this.searchTerm) {
        this.currentPage = 1;

        this.isTableLoading = true;

        await this.fetchVatTuItems(this.currentPage);
      }
    }, 500),

    onRowClick(row: IVatTuResponseBase, value: boolean) {
      const index = this.vatTuItems.findIndex((item) => item.id === row.id);

      this.selectedVatTuIdArr[index] = value;

      const foundIndex = this.selectedVatTuIds.findIndex((id) => id === row.id);

      if (foundIndex >= 0) {
        this.selectedVatTuIds.splice(foundIndex, 1);
      } else {
        this.selectedVatTuIds.push(row.id);
      }
    },

    onClose() {
      this.isOpen = false;
      this.$emit('close');
    },

    async fetchVatTuItems(page) {
      try {
        const {
          data: {
            data: { data: items, total },
          },
        } = await VatTuService.list({
          current_page: page,
          per_page: 20,
          s: this.searchTerm,
          is_valid: 1,
        });

        this.vatTuItems = items;

        this.totalItems = total;

        this.isTableLoading = false;
      } catch {
        this.isTableLoading = false;

        await swalNotification(
          'Có lỗi xảy ra khi lấy danh sách vật tư',
          'error'
        );
      }
    },

    onVatTuSelected(value, vatTuId, index) {
      this.selectedVatTuIdArr[index] = value;
      const foundIndex = this.selectedVatTuIds.findIndex(
        (id) => id === vatTuId
      );
      if (foundIndex >= 0) {
        this.selectedVatTuIds.splice(foundIndex, 1);
      } else this.selectedVatTuIds.push(vatTuId);
    },

    async submit() {
      try {
        await DanhMucVatTuService.themVatTuItems(
          this.danhMucVatTuId,
          this.selectedVatTuIds
        );

        this.isOpen = false;
        this.$emit('added');
      } catch {
        await swalNotification(
          'Có lỗi xảy ra khi thêm vật tư vào nhóm',
          'error'
        );
        this.onClose();
      }
    },
  },
});
